import { render } from "./WFamilia.vue?vue&type=template&id=3ef17d5a"
import script from "./WFamilia.vue?vue&type=script&lang=js"
export * from "./WFamilia.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__